import { Link } from 'react-router-dom';
import { getLatestStories } from '@/lib/content';

export default function DigestStrip() {
  const items = getLatestStories(5);

  return (
    <section className="w-full bg-primary-950 py-12 md:py-16" aria-label="今日速览">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="font-label text-xs font-medium uppercase tracking-[0.24em] text-accent-300">
              Daily digest
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              今日速览 · 60 秒概览
            </h2>
          </div>
          <Link
            to="/hot"
            className="inline-flex items-center gap-1 whitespace-nowrap font-label text-sm text-accent-300 transition-colors hover:text-accent-200"
          >
            查看全部速览
            <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
          </Link>
        </div>

        <ol className="mt-8 grid grid-cols-1 gap-x-8 gap-y-6 border-t border-primary-900 pt-8 sm:grid-cols-2 lg:grid-cols-5">
          {items.map((story, index) => (
            <li key={story.id} className="group">
              <Link to={`/article/${story.id}`} className="block">
                <span className="font-heading text-2xl font-black text-primary-700 transition-colors group-hover:text-accent-400">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-3 font-heading text-sm font-semibold leading-snug text-background-50 transition-colors group-hover:text-accent-300">
                  {story.title}
                </h3>
                <p className="mt-2 line-clamp-2 font-body text-xs leading-relaxed text-background-300">
                  {story.points[0]}
                </p>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}